import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import LookupPortal from '../pages/LookupPortal';
import TicketLookup from '../pages/TicketLookup';

// Không còn màn Login/Layout admin — toàn bộ app là public, chỉ gồm 2 trang tra cứu vé
// (clone từ lmsapp-service). "/:token" là catch-all nên PHẢI khai báo sau cùng.
const Index = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/tra-cuu-ket-qua" replace />} />
      <Route path="/tra-cuu-ket-qua" element={<LookupPortal />} />
      <Route path="/v/:token" element={<TicketLookup />} />
      <Route path="/:token" element={<TicketLookup />} />
    </Routes>
  );
};

export default Index;
